import React from 'react';
import { Card, Icon, Header } from 'semantic-ui-react';
import ButtonBar from './ButtonBar.js';
import i18next from 'i18next';

const Event = (props) => {
  const {
    title,
    endDate,
    beginDate,
    location,
    i18n_description,
    hasResults,
    hasSchedule,
    registrationEnabled
  } = props.data;

  // return (
  //   <Segment.Group>
  //     <Segment>
  //       <Header as='h1' content={title}/>
  //     </Segment>
  //     <Segment>
  //       {beginDate} - {endDate}
  //       {
  //         location &&
  //           <a icon='map pin'><Icon name='map pin'/>{location}</a>
  //       }
  //     </Segment>
  //     <Segment>
  //       {i18n_description[i18next.language]}
  //     </Segment>
  //     <Segment inverted>
  //       <ButtonBar
  //         hasResults={hasResults}
  //         hasSchedule={hasSchedule}
  //         registrationEnabled={registrationEnabled}
  //       />
  //     </Segment>
  //   </Segment.Group>
  // );
  
  return (
    <Card fluid className="rtxCard">
      <Card.Content>
        <Card.Header>
          <Header
            as='h1'
            content={title}
            className='rtxCardHeader'
          />
        </Card.Header>
        <Card.Meta>
          <span>
            {beginDate} - {endDate}
          </span>
          {
            location &&
              <a icon='map pin'><Icon name='map pin'/>{location}</a>
          }
        </Card.Meta>
        <Card.Description content={i18n_description[i18next.language]} />
      </Card.Content>
      <Card.Content extra>
        <ButtonBar
          hasResults={hasResults}
          hasSchedule={hasSchedule}
          /* TODO: this is an ugly hack. API responds with {BOOL: false} */
          /* in case of false value */
          registrationEnabled={registrationEnabled === true}
        />
      </Card.Content>
    </Card>
  );
};

export default Event;



// WEBPACK FOOTER //
// ./src/public/components/EventsList/Event/index.js